module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(3);
var React = __webpack_require__(4);
var react_dom_1 = __webpack_require__(5);
var InputMask = __webpack_require__(6);
var styles = __webpack_require__(7);
var VisualSize;
(function (VisualSize) {
    VisualSize[VisualSize["SMALL"] = 0] = "SMALL";
    VisualSize[VisualSize["MEDIUM"] = 1] = "MEDIUM";
    VisualSize[VisualSize["LARGE"] = 2] = "LARGE";
    VisualSize[VisualSize["MOBILE_MEDIUM"] = 3] = "MOBILE_MEDIUM";
})(VisualSize = exports.VisualSize || (exports.VisualSize = {}));
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            _this.props.onValueChange(event.currentTarget.value);
        };
        return _this;
    }
    Object.defineProperty(TextField.prototype, "input", {
        get: function () {
            return react_dom_1.findDOMNode(this).querySelector('input');
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.focus = function () {
        this.input.focus();
    };
    TextField.prototype.blur = function () {
        this.input.blur();
    };
    TextField.prototype.setSelectionRange = function (selectionStart, selectionEnd) {
        this.input.setSelectionRange(selectionStart, selectionEnd);
    };
    Object.defineProperty(TextField.prototype, "selectionStart", {
        get: function () {
            try {
                return this.input.selectionStart;
            }
            catch (ex) {
                return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        get: function () {
            try {
                return this.input.selectionEnd;
            }
            catch (ex) {
                return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.render = function () {
        var _a = this.props, size = _a.size, required = _a.required, invalid = _a.invalid, important = _a.important;
        var sharedProps = {
            type: this.props.type,
            placeholder: this.props.placeholder,
            id: this.props.id,
            name: this.props.name,
            autoFocus: this.props.autoFocus,
            autoComplete: 'off',
            autoCorrect: this.props.autoCorrect,
            max: this.props.maxValue,
            min: this.props.minValue,
            step: this.props.step,
            maxLength: this.props.maxLength,
            inputMode: this.props.inputMode,
            pattern: this.props.pattern,
            disabled: this.props.disabled,
            value: this.props.value,
            onChange: this.onChange,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur,
            onKeyDown: this.props.onKeyDown,
            onPaste: this.props.onPaste,
        };
        var sharedStyles = utils_1.mergeStyles(styles['input'], invalid && styles['invalid'], important && styles['important'], size === VisualSize.SMALL && styles['small'], size === VisualSize.MEDIUM && styles['medium'], size === VisualSize.LARGE && styles['large'], this.props.inputStyle);
        var renderedInput = this.props.mask
            ? React.createElement(InputMask, tslib_1.__assign({ mask: this.props.mask, maskChar: this.props.maskChar }, this.props.formatChars ? { formatChars: this.props.formatChars } : {}, { alwaysShowMask: this.props.alwaysShowMask }, sharedProps, sharedStyles))
            : React.createElement("input", tslib_1.__assign({}, sharedProps, sharedStyles));
        return (React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], required && styles['required'], this.props.containerStyle)),
            renderedInput,
            this.renderClearButton(size)));
    };
    TextField.prototype.renderClearButton = function (size) {
        if (this.props.value && this.props.onClear) {
            return (React.createElement("button", tslib_1.__assign({}, utils_1.mergeStyles(styles['clear'], size === VisualSize.SMALL && styles['clear-small'], size === VisualSize.MEDIUM && styles['clear-medium'], size === VisualSize.LARGE && styles['clear-large']), { type: "button", onClick: this.props.onClear })));
        }
        return null;
    };
    TextField.defaultProps = {
        type: 'text',
        size: VisualSize.SMALL,
    };
    return TextField;
}(React.Component));
exports.TextField = TextField;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@cian/utils");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("react-input-mask");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"text_field_component-container-kY9UXu6YWke","input":"text_field_component-input-5f64BwmaU0m","important":"text_field_component-important-d8ATvtS6oSY","invalid":"text_field_component-invalid-9it0czdNmMw","required":"text_field_component-required-8KBQDEprR6a","small":"text_field_component-small-jMPIteIhwWA","medium":"text_field_component-medium-4vsqPcKX8cQ","large":"text_field_component-large-am1CzSBiOOy","clear":"text_field_component-clear-hI4rBHjWGOy","clear-small":"text_field_component-clear-small-19pt29FQVwc","clear-medium":"text_field_component-clear-medium-e0YQziJVu08","clear-large":"text_field_component-clear-large-g2AvzSruHQW"};

/***/ })
/******/ ]);
//# sourceMappingURL=text-field-component.js.map